import { lazy } from 'react';

export const CalculationStructure = lazy(() =>
    import('./UerCalculationStructure').then((module) => ({ default: module.CalculationStructure })),
);
